'use strict';

/*
 *  Currency Selector
 *    Shopify Plus Multicurrency selector. Submits form on change of currency
 *
 *
 *  Version:
 *    1.0.0 - 2020/06/16
 */

$('.shopify-currency-form select').on('change', function () {
  $(this).parents('form').submit();
});